import { render, staticRenderFns } from "./EditorCompleteStageButton.vue?vue&type=template&id=068b234c&scoped=true&"
import script from "./EditorCompleteStageButton.vue?vue&type=script&lang=js&"
export * from "./EditorCompleteStageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b234c",
  null
  
)

export default component.exports